import React, { setState } from "react";
import { Form, Field, withFormik } from "formik";
import * as yup from "yup"; // Form Debugger
// import { Debug } from "./Debug";

import { Row, Col, Button } from "react-bootstrap"; // Global Element

import { FormCheckbox } from "../forms/elements";
var formikEnhancer = withFormik({
  enableReinitialize: true,
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      preferredLocation: props.preferredLocation,
      setPreferred: props.setPreferred
    };
  },
  displayName: "PreferredLocationForm" // helps with React DevTools

});

var PreferredLocationForm = function PreferredLocationForm(props) {
  var id = props.id,
      values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset;
  return /*#__PURE__*/React.createElement(Form, {
    className: "cb-form cb-location-card__preferred d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: id,
    type: "checkbox",
    name: "preferredLocation",
    label: "Set as preferred location",
    component: FormCheckbox,
    checked: props.setPreferred,
    onClick: function onClick(e) {
      var location = e.target.checked ? e.target.value : null;
      return props.handlePreferred(location);
    }
  }))));
};

export default formikEnhancer(PreferredLocationForm);